import { render, staticRenderFns } from "./ContractCard.vue?vue&type=template&id=6b667964&scoped=true"
import script from "./ContractCard.vue?vue&type=script&lang=ts"
export * from "./ContractCard.vue?vue&type=script&lang=ts"
import style0 from "./ContractCard.vue?vue&type=style&index=0&id=6b667964&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b667964",
  null
  
)

export default component.exports